import React, { useContext, useEffect, useState } from "react";
import { Modal, Spinner, Table } from "react-bootstrap";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./gma.css";
import InputBar from "../minda/InputBar/InputBar";
import { useSelector } from "react-redux";
import { AuthInfo, ConfigContext } from "../../../../App";
import { isIsoDate, jsonToURL, locale, msToHHMMSS } from "../../../../utils";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import { StrokesGraph } from "../minda/Strokes/Graph";
import { useSearchParams } from "react-router-dom";

export const GMA = (props) => {
  const { companyId, mmHost } = useContext(ConfigContext);
  const { userInfo, userId } = useContext(AuthInfo);

  return (
    <>
      <div className="box box-default">
        <div className="box-header">
          <InputBar
            setData={1}
            setFetchStatus={1}
            fetchStatus={1}
            loading={1}
            InsIden={"gma"}
            machineType={true}
            line={true}
            machine={true}
            shift={true}
            shiftDate={true}
            startTime={true}
            endTime={true}
          ></InputBar>
        </div>
        <div className="box-body">
          
        </div>
        <br></br>
        <br></br>        
      </div>
    </>
  );
};